module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем информацию..."
    }
  }) : (_vm.saving) ? _c('loading', {
    attrs: {
      "message": "Сохраняем информацию..."
    }
  }) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-10 col-lg-8"
  }, [_c('admin-card', [_c('admin-form-input', {
    attrs: {
      "label-text": 'Название',
      "label-id": 'inputName',
      "input-require": true,
      "error": _vm.$v.newDataItem.name.$error,
      "error-text": 'Название обязательно должно быть указано, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.name.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.name),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "name", $$v)
      },
      expression: "newDataItem.name"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Код',
      "label-id": 'inputCode',
      "input-require": true,
      "error": _vm.$v.newDataItem.code.$error,
      "error-text": 'Код обязательно должн быть указан, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.code.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.code),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "code", $$v)
      },
      expression: "newDataItem.code"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Класс',
      "label-id": 'inputClass',
      "input-require": true,
      "error": _vm.$v.newDataItem.class.$error,
      "error-text": 'Класс обязательно должн быть указан, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.class.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.class),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "class", $$v)
      },
      expression: "newDataItem.class"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Сортировка статуса',
      "label-id": 'inputSort',
      "input-require": true,
      "error": _vm.$v.newDataItem.sort.$error,
      "error-text": 'Допустимо только число'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.sort.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.sort),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "sort", $$v)
      },
      expression: "newDataItem.sort"
    }
  }), _vm._v(" "), _c('admin-form-check-box', {
    attrs: {
      "label-text": 'Активен'
    },
    model: {
      value: (_vm.newDataItem.enabled),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "enabled", $$v)
      },
      expression: "newDataItem.enabled"
    }
  }), _vm._v(" "), _c('admin-form-multi-select', {
    attrs: {
      "options": _vm.amoStatuses,
      "label-text": 'Id соответсвующих статутсов в Amo Crm',
      "label": "name",
      "trackBy": "name",
      "multiple": true
    },
    model: {
      value: (_vm.newDataItem.amoStatuses),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "amoStatuses", $$v)
      },
      expression: "newDataItem.amoStatuses"
    }
  }), _vm._v(" "), _c('template', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.newDataItem.id) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить статус")]], 2) : _vm._e()])], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-45234b10"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin/Statuses/StatusEdit.vue
// module id = 1031
// module chunks = 1